import { useNavigate } from "react-router";

import type { AutomatedSurveyRequest } from "@/api/types";
import { automatedSurveyMutations } from "@/queries/automated-surveys/mutations";
import { routes } from "@/routes";

import { automatedSurveyQuestionCategories, automatedSurveyTypes } from "../../constants";
import { AutomatedSurveyForm, type FormValues } from "./AutomatedSurveyForm";

export function CreateAutomatedSurveyPage(): React.ReactNode {
  const navigate = useNavigate();
  const createAutomatedSurvey = automatedSurveyMutations.useCreateAutomatedSurvey();
  const defaultFormValues = {
    name: "",
    description: "",
    thanksMessage: "",
    interval: "0",
    minSampleSize: "0",
    type: automatedSurveyTypes[0],
    projects: [],
    active: false,
    questions: automatedSurveyQuestionCategories
      .filter((category) => category.mandatory)
      .map((category) => ({ category, ratingQuestion: "", openQuestion: "", explanation: "" })),
  } satisfies FormValues;

  const handleSubmit = (payload: AutomatedSurveyRequest) =>
    createAutomatedSurvey.mutateAsync(payload, {
      onSuccess: () => {
        void navigate(routes.automatedSurveys.list());
      },
    });

  return (
    <AutomatedSurveyForm
      mode="create"
      defaultFormValues={defaultFormValues}
      isSubmitting={createAutomatedSurvey.isPending}
      onSubmit={handleSubmit}
    />
  );
}
